import { CircleCheck, GalleryVerticalEnd, Inbox, Target } from "lucide-react"

export const teams = [{ name: "TeachMe2", logo: GalleryVerticalEnd, plan: "Sales" }]

// tm2-sales has no router: the main view lives in the Freezer store
// (ui.main_view) and is switched via store.emit('ui:main_view:set', view).
// `view` here is the value passed to that event; backlog is the default
// view, so anything that isn't pipeline/tasks counts as backlog-active.
export const navMain = [
  { title: "Pipeline", view: "pipeline", icon: Target },
  { title: "Tasks", view: "tasks", icon: CircleCheck },
  { title: "My work", view: "backlog", icon: Inbox },
]

export function isViewActive(view, mainView) {
  if (view === "pipeline" || view === "tasks") return mainView === view
  return mainView !== "pipeline" && mainView !== "tasks"
}
